import _ from "lodash";
import BoletaService from "../provider/Boleta/BoletaService";
import { SUCCESS, ERROR, WARNING } from "../common/Util";
import Util from "../common/Util";
import { CHANGE_APP_PROPS, CHANGE_BOLETA_PROPS } from "./ActionConstants";

export function actionGetBoletasList(
	empresa,
	companyName,
	mes,
	anio,
	offset,
	limit,
	cuit
) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetBoletaList(
			empresa,
			companyName,
			mes,
			anio,
			offset,
			limit,
			cuit
		).then(response => {
			dispatch({
				type: CHANGE_BOLETA_PROPS,
				props: {
					boletasList: response ? response : [],
					total: !_.isEmpty(response) ? response[0].cant : 0
				}
			});
			dispatch({
				type: CHANGE_APP_PROPS,
				props: {
					loading: false
				}
			});
		});
	};
}

async function asyncGetBoletaList(
	empresa,
	companyName,
	mes,
	anio,
	offset,
	limit,
	cuit
) {
	let response = await BoletaService.getBoletaList(
		empresa,
		companyName,
		mes,
		anio,
		offset,
		limit,
		cuit
	);
	return response;
}

export function actionCreateBoleta(values, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		values = formatObjectToJSON(values);
		asyncCreateBoleta(values)
			.then(response => {
				//TODO
				if (response.code)
					if (response.code === 50015202) {
						callback(WARNING);
					} else {
						callback(ERROR);
					}
				else callback(SUCCESS);
			})
			.catch(error => {
				//TODO
				error.then(value => {
					if (value.code && value.code === 50015202) {
						callback(WARNING);
					} else {
						callback(ERROR);
					}
				});
			})
			.then(() => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}

function formatObjectToJSON(values) {
	if (values.from_date) {
		values.from_date = Util.formatDateTimeToISODateTime(
			values.from_date,
			values.from_time
		);
	}
	if (values.to_date) {
		values.to_date = Util.formatDateTimeToISODateTime(
			values.to_date,
			values.to_time
		);
	}
	if (values.boleta_type) {
		values.boleta_type = { id: values.boleta_type };
	}
	delete values.from_time;
	delete values.to_time;
	return values;
}

async function asyncCreateBoleta(values) {
	return await BoletaService.setBoleta(values);
}

export function actionUpdateBoleta(values, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: { loading: true }
		});
		values = formatObjectToJSON(values);
		asyncUpdateBoleta(values)
			.then(response => {
				callback(true);
			})
			.catch(error => {
				callback(false);
			})
			.then(() => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: { loading: false }
				});
			});
	};
}

async function asyncUpdateBoleta(values) {
	return await BoletaService.updateBoleta(values);
}

export function actionChangeBoletaProps(props) {
	return dispatch => {
		dispatch({
			type: CHANGE_BOLETA_PROPS,
			props: props
		});
	};
}

export function actionGenerarBoletaPago(callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGenerarBoletaPago()
			.then(response => {
				// response.text().then((data) => {
				//   returnGenerateXls(data);
				// }
				callback(response);
			})
			.catch(error => {
				callback(ERROR);
			});
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: false
			}
		});
	};
}

async function asyncGenerarBoletaPago() {
	//TODO
	let response = await BoletaService.generarBoletaPago();
	return response;
}

export function actionDownloadFile(fileName, returnDownload) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncDownloadFile(fileName).then(response => {
			dispatch({
				type: CHANGE_APP_PROPS,
				props: {
					loading: false
				}
			});
			// Toma la ruta del reporte generado.
			returnDownload(response);
		});
	};
}

async function asyncDownloadFile(fileName) {
	try {
		let response = await BoletaService.downloadFile(fileName);
		return response;
	} catch (error) {
		return error;
	}
}

export function actionProcessFile(fileName, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncDownloadProcessFile(fileName)
			.then(response => {
				callback(SUCCESS, response);
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.catch(error => {
				callback(ERROR, error);
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}

async function asyncDownloadProcessFile(file) {
	var formData = new FormData();
	formData.append("type", "file");
	formData.append("file", file);
	let response = await BoletaService.processFile(formData);
	return response;
}

export function actionPrintTicket(
	idPayment,
	idTicketHeader,
	onDemand,
	callback
) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncPrintTicket(idPayment, idTicketHeader, onDemand)
			.then(response => {
				callback(response);
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.catch(error => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}

async function asyncPrintTicket(idPayment, idTicketHeader, onDemand) {
	let response = await BoletaService.printTicket(
		idPayment,
		idTicketHeader,
		onDemand
	);
	return response;
}

export function actionRegenerateTicket(
	idPayment,
	idExpiredTicketHeader,
	callback
) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncRegenerateTicket(idPayment, idExpiredTicketHeader)
			.then(response => {
				callback(response);
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.catch(error => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}

async function asyncRegenerateTicket(idPayment, idTicketHeader) {
	let response = await BoletaService.regenerateTicket(
		idPayment,
		idTicketHeader
	);
	return response;
}

export function actionSetTicketAsPaid(idTicketHeader, paidDate, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncSetTicketAsPaid(idTicketHeader, paidDate)
			.then(response => {
				callback(SUCCESS);
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.catch(error => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}

async function asyncSetTicketAsPaid(idTicketHeader, paidDate) {
	let response = await BoletaService.setAsPaid(idTicketHeader, paidDate);
	return response;
}

export function actionGenerateTicketOnDemand(ticket, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGenerateTicketOnDemand(ticket)
			.then(response => {
				callback(response);
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.catch(error => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}

async function asyncGenerateTicketOnDemand(ticket) {
	return await BoletaService.generateTicketOnDemand(ticket);
}

export function actionRegenerateTicketOnDemand(
	idPayment,
	idExpiredTicketHeader,
	ticketOnDemand,
	callback
) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncRegenerateTicketOnDemand(
			idPayment,
			idExpiredTicketHeader,
			ticketOnDemand
		)
			.then(response => {
				callback(response);
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.catch(error => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}

async function asyncRegenerateTicketOnDemand(
	idPayment,
	idTicketHeader,
	ticketOnDemand
) {
	return await BoletaService.regenerateTicketOnDemand(
		idPayment,
		idTicketHeader,
		ticketOnDemand
	);
}

export function actionProcessTxt(txtFile, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true,
				loadingText: "Procesando"
			}
		});
		asyncProcessTxt(txtFile)
			.then(response => {
				callback(SUCCESS);
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false,
						loadingText: "Cargando"
					}
				});
			})
			.catch(error => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false,
						loadingText: "Cargando"
					}
				});
			});
	};
}

async function asyncProcessTxt(txtFile) {
	var formData = new FormData();
	formData.append("type", "file");
	formData.append("file", txtFile);
	let response = await BoletaService.processTxt(formData);
	return response;
}

export function actionGetEmpresaMovementList(idEmpresa) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetEmpresaMovementList(idEmpresa)
			.then(response => {
				dispatch({
					type: CHANGE_BOLETA_PROPS,
					props: {
						boletasList: response ? response : []
					}
				});
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.catch(err => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}

async function asyncGetEmpresaMovementList(idEmpresa) {
	let response = await BoletaService.getEmpresaMovementList(idEmpresa);
	return response;
}



// WEBPACK FOOTER //
// ./src/actions/BoletaActions.js